<div
  *ngIf="!isAcmic && policy?.displayType?.label === 'Personal property' && policy?.billingDetails?.[0]?.mortageeFlag === 'Y'"
>
  <div class="mortgagee-row">
    <div class="mortgagee-left">
      <span class="mortgagee-text color-2D373D">
        {{ 'MORTGAGEE_TEXT' | translate }}
      </span>
      <app-mortgagee-custom-tooltip></app-mortgagee-custom-tooltip>
    </div>

    <div *ngIf="policy?.billingDetails?.mortgagee && policy?.billingDetails?.mortgagee?.name && policy?.billingDetails?.mortgagee?.address" class="mortgagee-right">
      <div class="company-name lh-21">
        {{ policy?.billingDetails?.mortgagee?.name | titlecase}}
      </div>

      <div class="lh-24 mrb-1 h-21">
        {{ policy?.billingDetails?.mortgagee?.address?.line1 }}
      </div>

      <div class="lh-24 h-21">
        {{ policy?.billingDetails?.mortgagee?.address?.city }},
        {{ policy?.billingDetails?.mortgagee?.address?.state }}
        {{ policy?.billingDetails?.mortgagee?.address?.zip?.code }}
      </div>
    </div>
  </div>
  <hr class="thin-hr" />
</div>

<ng-container *ngIf="isRenewalPolicy && policy?.days_left_to_expire > 0 && !isHideNotice">
  <div class="renewal-notice-container" [ngClass]="{'mb-3': !isAcmic && variant === 'policy-card'}">
    <div
      class="warning-icon-block"
      [ngClass]="{ 'acmic-warning-block-rounded': isAcmic }"
    >
      <img src="./assets/img/images/icon-warning-yellow.svg" alt="warning icon" />
    </div>
    <div class="notice-info-block">
      <div class="row-space-between align-items-start">
        <div class="main-notice-info">
          {{ 'Your renewal is happening in ' }} {{ policy?.days_left_to_expire }}
          {{ ' days!' }}
        </div>
        <img
          src="./assets/img/images/icon-close-18.svg"
          class="cursor-pointer ml-3"
          alt="close icon"
          (click)="onClose()"
        />
      </div>
      <div>{{ 'REVIEW_POLICY_UPDATES_CHANGES' | translate }}</div>
      <hr class="thin-hr-mb-24 mb-0 mt-0" />
      <div>{{ 'CONTACT_AGENT_ABOUT_COVERAGES_DISCOUNT' | translate }}</div>
      <div
        [routerLink]="[
          '/my-insurance',
          policy?.policynumber.policyNumber,
          'documents'
        ]"
        class="bold-link"
      >
        {{ 'View renewal documents' | translate }}
      </div>
    </div>
  </div>
  <hr class="my-insurance-main-hr" *ngIf="variant === 'policy-card'">
</ng-container>

